import React, { useContext, useEffect, useState } from 'react'
import { RateAndAccuracyHeaderStyles } from './Style'
import { AssessmentsContext } from './AssessmentsContext'
import { ReactComponent as NotificationIcon } from 'assets/icons/Notification.svg';
import { ReactComponent as NumbersIcon } from 'assets/icons/Numbers.svg';
import { ReactComponent as ListIcon } from 'assets/icons/List.svg';
import { IconButtonGroup } from 'components/Form';

const RateAndAccuracyHeader = (props) => {
    const { column } = props
    const { meta, accessorKey } = column?.columnDef || {}

    const viewNextTypes = {
        icon: {
            type: "label",
            icon: ListIcon,
            tooltip: "מעבר לתצוגת הטקסטים"
        },
        label: {
            type: "value",
            icon: NumbersIcon,
            tooltip: "מעבר לתצוגת הערכים"
        },
        value: {
            type: "icon",
            icon: NotificationIcon,
            tooltip: "מעבר לתצוגת הסמלים"
        }
    }

    const { viewCell, setViewCell } = useContext(AssessmentsContext)
    const [headerIconCell, setHeaderIconCell] = useState(viewNextTypes[viewCell[accessorKey]])

    useEffect(() => {
        setHeaderIconCell(viewNextTypes[viewCell[accessorKey]])
    }, [viewCell])

    const updateHeaderView = (e) => {
        let nViewCell = viewCell[accessorKey]
        nViewCell = viewNextTypes[nViewCell].type
        setHeaderIconCell(viewNextTypes?.[nViewCell])
        setViewCell({ ...viewCell, [accessorKey]: nViewCell })
        e.stopPropagation()
        e.preventDefault()
    }

    return (
        <RateAndAccuracyHeaderStyles>
            <div className='cell-with-icon'>
                {meta?.label}
            </div>
            {meta.tooltip &&
                <div className='tooltip'>
                    <meta.tooltip />
                </div>}
            <IconButtonGroup
                color="thirdly4"
                placement='top'
                tooltip={headerIconCell?.tooltip}
                size="small"
                lightColor
                selected={true}
                icon={headerIconCell?.icon}
                action={updateHeaderView}
                iconSize={{
                    width: 20,
                    height: 20
                }}
            />

        </RateAndAccuracyHeaderStyles>
    )
}

export default RateAndAccuracyHeader